/**
 * Developed by Artie Codes for Stone & Wood
 *
 * Mobile megamenu subdrawer (drilldown pattern)
 * --------------------------------------------------------------------------
 * When a level-2 menu item with children is tapped, the corresponding
 * subdrawer slides in over the megamenu. Back closes it; Esc closes the
 * top-most open subdrawer.
 *
 * Triggers: [data-mm-subdrawer-open="<id>"]
 * Closers (back):       [data-mm-subdrawer-close]   (within the subdrawer)
 * Closers (close all):  .js-close-menu              (megamenu X button)
 *
 * Listens in CAPTURE phase + on pointerdown so it wins against any other
 * handler in the theme that might preventDefault on touchstart (an iOS
 * Safari gotcha that suppresses the synthesized click).
 */
(function () {
  'use strict';

  function openSubdrawer(trigger) {
    var id = trigger.getAttribute('data-mm-subdrawer-open');
    if (!id) return;
    var drawer = document.getElementById(id);
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mm-subdrawer-open');

    // Move focus to the back button for keyboard / a11y
    var backBtn = drawer.querySelector('[data-mm-subdrawer-close]');
    if (backBtn) {
      window.setTimeout(function () { backBtn.focus(); }, 250);
    }
  }

  function closeSubdrawer(drawer, returnFocus) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    var trigger = document.querySelector(
      '[data-mm-subdrawer-open="' + drawer.id + '"]'
    );
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    }

    // Release the body scroll lock when no subdrawers remain open
    if (!document.querySelector('.mm-subdrawer.is-open')) {
      document.body.classList.remove('mm-subdrawer-open');
    }
  }

  function closeAllSubdrawers() {
    var open = document.querySelectorAll('.mm-subdrawer.is-open');
    for (var i = 0; i < open.length; i++) {
      closeSubdrawer(open[i], false);
    }
    document.body.classList.remove('mm-subdrawer-open');
  }

  // Dedupe so pointerdown + click don't both fire the same trigger
  var lastHandledTrigger = null;
  var lastHandledAt = 0;

  function handleActivation(e) {
    if (!e.target || !e.target.closest) return;

    // Open trigger
    var trigger = e.target.closest('[data-mm-subdrawer-open]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      if (trigger === lastHandledTrigger && (Date.now() - lastHandledAt) < 500) {
        // Already handled by the matching pointerdown — swallow the click
        return;
      }
      lastHandledTrigger = trigger;
      lastHandledAt = Date.now();
      openSubdrawer(trigger);
      return;
    }

    // Back button
    var backBtn = e.target.closest('[data-mm-subdrawer-close]');
    if (backBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      closeSubdrawer(backBtn.closest('.mm-subdrawer'), true);
      return;
    }
  }

  function init() {
    // Capture phase (third arg = true) so we run before any bubble-phase
    // handler in the theme can swallow or redirect the event.
    document.addEventListener('pointerdown', handleActivation, true);
    document.addEventListener('click', handleActivation, true);

    // Esc closes the top-most open subdrawer
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var open = document.querySelectorAll('.mm-subdrawer.is-open');
      if (open.length === 0) return;
      closeSubdrawer(open[open.length - 1], true);
    });

    // The megamenu X button (.js-close-menu) closes everything.
    // Bubble-phase here is fine — we want the existing close handler to run too.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.js-close-menu')) {
        closeAllSubdrawers();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();